export type HealthCheckResult = {
  online: boolean;
  endpoint: string;
  checkedAt: Date;
  networkOnline: boolean;
  httpStatus?: number;
  status: string;
  database: string;
  version?: string;
  errorCode?: string;
  errorMessage?: string;
};

type HealthPayload = {
  status?: unknown;
  app?: unknown;
  database?: unknown;
  version?: unknown;
  timestamp?: unknown;
};

export function healthEndpoint() {
  return `${window.location.origin}/api/health`;
}

export function isMobileAccess() {
  return /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent);
}

export async function checkCceHealth(timeoutMs = 8_000): Promise<HealthCheckResult> {
  const endpoint = healthEndpoint();
  const checkedAt = new Date();
  const networkOnline = navigator.onLine;
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch("/api/health", {
      cache: "no-store",
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: controller.signal,
    });
    const httpStatus = response.status;
    const contentType = response.headers.get("content-type") || "";
    if (!contentType.toLowerCase().includes("application/json")) {
      return {
        online: false,
        endpoint,
        checkedAt,
        networkOnline,
        httpStatus,
        status: "resposta_inválida",
        database: "desconhecido",
        errorCode: "HEALTH_INVALID_CONTENT",
        errorMessage: "O health check retornou conteúdo diferente de JSON.",
      };
    }

    const payload = await response.json() as HealthPayload;
    const status = String(payload.status || "desconhecido");
    const database = String(payload.database || "desconhecido");
    const app = String(payload.app || "");
    const healthy = response.ok && status === "ok" && database === "connected" && app.startsWith("CCE Gestão");

    return {
      online: healthy,
      endpoint,
      checkedAt,
      networkOnline,
      httpStatus,
      status,
      database,
      version: typeof payload.version === "string" ? payload.version : undefined,
      errorCode: healthy ? undefined : `HEALTH_${httpStatus}_${status.toUpperCase()}`,
      errorMessage: healthy ? undefined : "O servidor respondeu, mas o health check ou o banco não foi aprovado.",
    };
  } catch (error) {
    const aborted = error instanceof DOMException && error.name === "AbortError";
    return {
      online: false,
      endpoint,
      checkedAt,
      networkOnline,
      status: "indisponível",
      database: "não verificado",
      errorCode: aborted ? "HEALTH_TIMEOUT" : networkOnline ? "HEALTH_NETWORK_ERROR" : "BROWSER_OFFLINE",
      errorMessage: aborted
        ? `O servidor não respondeu em ${Math.round(timeoutMs / 1_000)} segundos.`
        : networkOnline
          ? "Não foi possível alcançar o servidor nesta origem."
          : "O dispositivo informou que está sem conexão de rede.",
    };
  } finally {
    window.clearTimeout(timeout);
  }
}
